import { SiteLogPreviewResponse } from "../models/site";
import axiosConfig from "./axiosConfig";

const postSiteLogPreview = async (
  authToken: string,
  siteId: string,
  update: any
): Promise<SiteLogPreviewResponse> => {
  const { data } = await axiosConfig.post(`/site/${siteId}/log`, update, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default postSiteLogPreview;
